"use strict";

exports.__esModule = true;
exports.flattenMetricResponse = flattenMetricResponse;
function flattenMetricResponse(metricName, response) {
  var flattened = [];
  for (var _i = 0, _Object$keys = Object.keys(response); _i < _Object$keys.length; _i++) {
    var binName = _Object$keys[_i];
    var values = response[binName];
    collectBin(flattened, metricName, binName, values, {});
  }
  return flattened;
}
function collectBin(collected, metricName, binName, values, parentKey) {
  if (!Array.isArray(values)) {
    return;
  }
  for (var i = 0; i < values.length; i++) {
    var _Object$assign;
    var item = values[i];
    var key = Object.assign({}, parentKey, (_Object$assign = {}, _Object$assign[normalizeBinName(binName)] = item.key, _Object$assign));
    for (var _i2 = 0, _Object$keys2 = Object.keys(item); _i2 < _Object$keys2.length; _i2++) {
      var name = _Object$keys2[_i2];
      if (name === "key") {
        continue;
      }
      var value = item[name];
      if (name === "value") {
        var _Object$assign2;
        collected.push(Object.assign({}, key, (_Object$assign2 = {}, _Object$assign2[metricName] = value, _Object$assign2)));
      } else {
        collectBin(collected, metricName, name, value, key);
      }
    }
  }
}
function normalizeBinName(input) {
  if (input.startsWith("by_")) {
    return input.slice(3);
  }
  return input;
}